<button matTooltip="Increase Zoom" matTooltipShowDelay="200" matTooltipPosition="left" [class.disabled]="scale === maxScale || disable"
  (click)="handleStep(1)" aria-label="Increase Zoom">
  <icon name="plus"></icon>
</button>
@if (!justButtons) {
  <div id="scale-display" [ngClass]="percentage !== 100 ? 'actionon': 'actionoff'">{{percentage}}%</div>
}
<button matTooltip="Decrease Zoom" matTooltipShowDelay="200" matTooltipPosition="left" [class.disabled]="scale === minScale || disable"
  (click)="handleStep(-1)" aria-label="Decrease Zoom">
  <icon name="minus"></icon>
</button>